var SJ = SJ || {};
var __ = __ || function (str) { return str; };

SJ.SitesCaptcha = SJ.SitesCaptcha || {
    // Variable to store session id which will come with captcha
    captcha_session: null,
    site_key: null,
    engine: null,
    initHandle: null,
    init: function () {
        if ( SJ.SitesCaptcha.initHandle != null && SJ.SitesCaptcha.engine != null ) {
            clearInterval(SJ.SitesCaptcha.initHandle);
            switch ( SJ.SitesCaptcha.engine ) {
                case SJ.SitesCaptcha.ReCaptcha.name:
                    SJ.SitesCaptcha.ReCaptcha.setup();
                    break;
                case SJ.SitesCaptcha.ReCaptcha3.name:
                    SJ.SitesCaptcha.ReCaptcha3.setup();
                    break;
                default :
                    SJ.SitesCaptcha.Captcha.init();
                    break;
            }
        }
    },
    setup: function (config) {
        for (var elem in config ) {
            this[elem] = config[elem];
        }
    },
    submitHandler: function (form) {
        if ( SJ.SitesCaptcha.engine ===  SJ.SitesCaptcha.ReCaptcha3.name ) {
            var inputField = $(form).find('input[name="recaptcha-token"]');
            if (inputField.length) {
                grecaptcha.ready(function() {
                    grecaptcha.execute(SJ.SitesCaptcha.site_key, {action: 'submit'})
                        .then(function(token) {
                            inputField.val(token);
                            form.submit();
                        })
                });
                return;
            }
        }
        form.submit();
    }
};

/**
 * Kohana Captcha
 */
SJ.SitesCaptcha.Captcha = SJ.SitesCaptcha.Captcha || {
    init: function () {
        // Do we have a session?
        var captcha_session_exists = $.cookie('session') !== undefined;

        var captcha_count = 0;
        $('.captcha-loading').each(function () {
            var $img = $(this);

            // Count number of captcha images on page
            captcha_count++;

            // When captcha img is loaded
            $(this).on('load', function () {
                // Check if it is our change of the src or the initial loading
                if ( $img.attr('src') === $img.data('src') ) {
                    captcha_count--;
                    /*
                     * Handle cookie after every captcha images on page would be loaded
                     * (each comes with own session cookie set)
                     */
                    if ( !captcha_count && !captcha_session_exists ) {
                        setTimeout(function () {
                            // Store cookie for future use
                            SJ.SitesCaptcha.captcha_session = $.cookie('session');
                            // Clear cookie with session id
                            $.removeCookie('session');
                            $.removeCookie('session', { path: '/' });
                            //alert(document.cookie);
                        }, 500);
                    }
                }
            });

            // Switch loading images for proper captcha images
            $img.attr('src', $img.data('src'));

            if ( !captcha_session_exists ) {
                $img.closest('form').submit(function () {
                    // Set session id before user submits a form
                    $.cookie('session', SJ.SitesCaptcha.captcha_session, { path: '/' });
                });
            }
        });
    }
};

/**
 * ReCAPTCHA
 * @type {{site_key: null, setup: SJ.SitesRecaptcha.setup, init: SJ.SitesRecaptcha.init}}
 */
SJ.SitesCaptcha.ReCaptcha = SJ.SitesCaptcha.ReCaptcha || {
    name: 'recaptcha',
    setup: function () {
        //We have to it like this otherwise recaptcha is not gonna fire it
        window['SJ_SitesRecaptcha_Init'] = SJ.SitesCaptcha.ReCaptcha.init;
        $.getScript('https://www.google.com/recaptcha/api.js?onload=SJ_SitesRecaptcha_Init&render=explicit');
    },
    init: function () {
        //Callback initializing all recaptcha instances
        $('.g-recaptcha').each(function () {
            grecaptcha.render(this, {
                'sitekey': SJ.SitesCaptcha.site_key
            });
        })
    }
};

/**
 * ReCAPTCHAv3
 * @type {{site_key: null, setup: SJ.SitesCaptcha.ReCaptcha3.setup, init: SJ.SitesCaptcha.ReCaptcha3.init}}
 */
SJ.SitesCaptcha.ReCaptcha3 = SJ.SitesCaptcha.ReCaptcha3 || {
    name: 'recaptcha3',
    setup: function () {
        $.getScript(
            'https://www.google.com/recaptcha/api.js?render=' + SJ.SitesCaptcha.site_key
        );
    }
};

// Init all needed references
$(document).ready(function () {
    SJ.SitesCaptcha.initHandle = setInterval(SJ.SitesCaptcha.init, 50);
});

